import { useQuery } from '@tanstack/react-query';

import { axiosWithPasetoAuth } from '@telialt/utils/src/authentication/axiosWithPasetoAuth';
import { isSSR, withParams } from '@telialt/utils/src/helpers';
import { useResolution } from '@telialt/utils/src/hooks';
import { isDesktopRes } from '@telialt/utils/src/responsive';
import { TeliaSegment, useSegment } from '@telialt/utils/src/segment';

import { API } from '../api';
import { QUERY_KEYS } from '../constants';
import { PendingDocument } from '../model';

const getPendingDocuments = (segment: TeliaSegment) => {
    return axiosWithPasetoAuth.get<PendingDocument[]>(withParams(API.PENDING_DOCUMENTS, { segment }), {
        params: {
            status: 'NEW',
            signatureType: 'CLICK_AND_CONFIRM',
        },
    });
};

export const usePendingDocumentsQuery = (enabled: boolean) => {
    const segment = useSegment();
    const isDesktop = useResolution(() => !isSSR() && isDesktopRes());

    return useQuery({
        queryKey: [QUERY_KEYS.PENDING_DOCUMENTS, segment],
        queryFn: () => getPendingDocuments(segment),
        enabled: enabled && !isDesktop && segment === TeliaSegment.B2c,
        select: ({ data }) => data,
        staleTime: Infinity,
    });
};
